/* Howler configs without the Howl instance */
export default {
  music_RegularBattle: {
    src: [
      "/music/player-vs-computer.mp3"
    ],
    volume: 0.4,
    loop: true
  },
  music_b5Menu: {
    src: [
      "/music/basement.mp3"
    ],
    volume: 0.4,
    loop: true
  }
};

// import store from '../init/store'

// //SONG
// export const songRegularBattle = new Howl({
//     src: ['https://s3-us-west-2.amazonaws.com/s.cdpn.io/21542/battle-buns.mp3'],
//     volume: 0.4,
//     loop: true
//     // sprite: {
//     //     trimmed: [0, 60952.381, true]
//     // }
// });



// WEBPACK FOOTER //
// ./src/_audio/_music.js